export const apiBaseUrl = "https://smsvendor.com/api/v1";
export const imageBaseUrl = "https://smsvendor.com/avatar";
